var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"reward-chart-wrap"},[(!_vm.chartData || _vm.chartData.length === 0)?_c('div',{staticClass:"empty-box"},[_vm._v(" No Data ")]):_c('div',{style:({
      width: _vm.width,
      height: _vm.height
    }),attrs:{"id":_vm.chartId}})])}
var staticRenderFns = []

export { render, staticRenderFns }